import {
  CheckCircleOutlined,
  ErrorOutlineOutlined,
  BlockOutlined,
  PhoneForwardedOutlined,
} from "@mui/icons-material";
import { i18n } from "../translate/i18n";

const OUTCOME_META = {
  hangup: { key: "hangup", color: "#6b7280", icon: CheckCircleOutlined },
  socket_error: { key: "socketError", color: "#e53935", icon: ErrorOutlineOutlined },
  no_prompt: { key: "noPrompt", color: "#f59e0b", icon: BlockOutlined },
  server_error: { key: "serverError", color: "#e53935", icon: ErrorOutlineOutlined },
  transferred: { key: "transferred", color: "#2fae60", icon: PhoneForwardedOutlined },
  colgada: { key: "hangup", color: "#6b7280", icon: CheckCircleOutlined },
};

export const outcomeInfo = (outcome) => {
  const meta = OUTCOME_META[outcome];
  if (!meta) return { label: outcome || "—", color: "#6b7280", icon: CheckCircleOutlined };
  return { label: i18n.t(`callCommon.outcomes.${meta.key}`), color: meta.color, icon: meta.icon };
};

export const SATISFACTION_LEVELS = ["very_satisfied", "satisfied", "dissatisfied", "very_dissatisfied"];

export const SATISFIED_LEVELS = ["very_satisfied", "satisfied"];

const SENTIMENT_META = {
  very_satisfied: { key: "verySatisfied", color: "#2fae60", chipColor: "success" },
  satisfied: { key: "satisfied", color: "#8bc34a", chipColor: "success" },
  dissatisfied: { key: "dissatisfied", color: "#ffa726", chipColor: "warning" },
  very_dissatisfied: { key: "veryDissatisfied", color: "#e53935", chipColor: "error" },
};

export const sentimentInfo = (sentiment) => {
  const meta = SENTIMENT_META[sentiment];
  if (!meta) return null;
  return { label: i18n.t(`callCommon.sentiments.${meta.key}`), color: meta.color, chipColor: meta.chipColor };
};

const TRANSFER_STATUS_KEY = {
  ANSWER: "answer",
  BUSY: "busy",
  NOANSWER: "noAnswer",
  CANCEL: "cancel",
  CONGESTION: "congestion",
  CHANUNAVAIL: "chanUnavail",
};

// Combines the call outcome with the transfer's real DIALSTATUS, so the
// table can say "transferred and answered" vs "transferred but nobody
// picked up" -- before, both looked the same ("Transferred to an agent"),
// without saying whether it was actually resolved.
export const transferResultInfo = (dialStatus) => {
  if (!dialStatus) {
    return { label: i18n.t("callCommon.transferResult.unconfirmed"), color: "#6b7280", chipColor: "default" };
  }
  if (dialStatus === "ANSWER") {
    return { label: i18n.t("callCommon.transferResult.answered"), color: "#2fae60", chipColor: "success" };
  }
  const statusKey = TRANSFER_STATUS_KEY[dialStatus];
  const statusLabel = statusKey ? i18n.t(`callCommon.transferStatus.${statusKey}`) : dialStatus;
  return {
    label: i18n.t("callCommon.transferResult.notAnswered", { status: statusLabel }),
    color: "#e53935",
    chipColor: "error",
  };
};

export const formatDuration = (seconds) => {
  if (!seconds) return "—";
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return min > 0 ? `${min}m ${sec}s` : `${sec}s`;
};

export const formatFecha = (iso) => {
  const locale = i18n.language?.startsWith("en") ? "en-US" : "es-EC";
  try {
    return new Date(iso).toLocaleString(locale, { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
};
